export const fileFormatsToReadableText = fileFormats => {
  if (!fileFormats || fileFormats.length === 0) return '';
  const lastFormatAsText = `*${fileFormats[fileFormats.length - 1]}`;
  if (fileFormats.length === 1) return lastFormatAsText;
  return `${fileFormats
    .slice(0, fileFormats.length - 1)
    .map(format => `*${format}`)
    .join(', ')} or ${lastFormatAsText}`;
};

const optionValueToText = s => (s !== undefined && s !== null ? String(s) : '');

const operatorToText = {
  EQ: '',
  GTE: '>',
  LTE: '<',
  CONTAINS: '',
};

export const getMessageFromRequirement = (
  fileRequirement,
  shouldShowFormats = true,
) => {
  const formatsText = fileFormatsToReadableText(fileRequirement.formats);

  let valueText = optionValueToText(fileRequirement.valueInt);
  if (!valueText) valueText = optionValueToText(fileRequirement.valueFloat);
  if (!valueText) valueText = optionValueToText(fileRequirement.valueString);
  if (!valueText) valueText = optionValueToText(fileRequirement.valueBool);

  let operatorText = '';
  operatorText = operatorToText[fileRequirement.operator];
  if (operatorText === undefined) operatorText = '';

  const forText = `${fileRequirement.for.name} ${
    valueText ? ` was set to ${operatorText}${valueText}` : 'was selected'
  }`;

  return `A${
    shouldShowFormats ? ` ${formatsText}` : ''
  } supporting file is required because ${forText}.`;
};
